import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import { getPackageDetailsResponses, getShipmentResponses } from "../actions";

export function* schedulePickupEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`/delivery/schedule`, action?.payload)
    );
    action.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}
export function* createShipmentEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(
        `/delivery/create-shipment-orders?cartBundleId=${action?.payload?.cartBundleId}&addressId=${action?.payload?.addressId}`,
        action?.payload
      )
    );
    action.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* getShipmentEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(
        `/shipments/by-cart-bundle/${action?.payload?.cartBundleId}`,
        action?.payload
      )
    );
    action.payload?.callback?.success?.(data);
    // console.log()
    yield put(getShipmentResponses(data));
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
    yield put(getShipmentResponses({}));
  }
}

export function* getPackageDetailsEffectSaga(action) {
  try {
    const { data, status } = yield call(() =>
      axiosGet(`/delivery/${action?.payload?.shipmentId}`, action?.payload)
    );

    action.payload?.callback?.success?.(data);
    yield put(getPackageDetailsResponses(data));
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
    yield put(getPackageDetailsResponses({}));
  }
}
export function* updatePacakgeDetailsEffectSaga(action) {
  try {
    const { data, status } = yield call(() =>
      axiosGet(`/delivery/update-shipment`, action?.payload)
    );

    action.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}
export function* getReceiptEffectSaga(action) {
  try {
    const { data, status } = yield call(() =>
      axiosGet(
        `/delivery/package-slip?waybill=${action?.payload?.waybillNumber}&pdf=true`
      )
    );

    action.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* delhiveryWatcherSaga() {
  yield takeLatest(types.SCHEDULE_PICKUP, schedulePickupEffectSaga);
  yield takeLatest(types.CREATE_SHIPMENT, createShipmentEffectSaga);
  yield takeLatest(types.GET_SHIPMENT, getShipmentEffectSaga);
  yield takeLatest(types.GET_PACKAGE_DETAILS, getPackageDetailsEffectSaga);
  yield takeLatest(
    types.UPDATE_PACKAGE_DETAILS,
    updatePacakgeDetailsEffectSaga
  );
  yield takeLatest(types.GET_RECEIPT, getReceiptEffectSaga);
}
